import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, CardMedia, Grid, Typography} from '@mui/material';

import {bodyPdf, pdfH1, pdfH2} from './styles';
import contactPersonImage from '../../../assets/pdf/introduction/contact_person.jpg';
import introductionImage from '../../../assets/pdf/introduction/introduction.png';
import {CultureAnalysisPdfContext} from '../../../contexts/CultureAnalysisPdfContext/CultureAnalysisPdfContext';
import {greenColors, orangeColors} from '../../../layouts/theme/designSystem';
import {CONTACT_PERSON_EMAIL, CONTACT_PERSON_NAME, CONTACT_PERSON_POSITION} from '../../../lib/pdf-constants';

export const Introduction = () => {
  const {t} = useTranslation('pdfDomain');

  const {data, loading} = useContext(CultureAnalysisPdfContext);

  if (loading || !data) {
    return null;
  }

  return (
    <>
      <Grid container>
        <Box paddingTop={5} paddingRight={5} paddingLeft={5} paddingBottom={2}>
          <Typography variant='h1' sx={pdfH1}>
            {t('introductionPage.title', {companyName: data.company.name})}
          </Typography>
          <Typography variant='h2' sx={pdfH2}>
            {t('introductionPage.subtitle')}
          </Typography>
        </Box>

        <Grid container justifyContent={'center'} paddingTop={2} paddingRight={5} paddingLeft={5} paddingBottom={5}>
          <Grid
            container
            item
            justifyContent={'space-between'}
            alignItems={'center'}
            // height={'210px'}
            sx={{
              backgroundColor: orangeColors[4],
              border: `1px solid ${orangeColors[3]}`,
              borderRadius: 3,
              padding: 1.5,
            }}
          >
            <CardMedia
              component={'img'}
              src={data.cultureInformation.cultureType.imageUrl}
              sx={{height: '160px', width: '170px', objectFit: 'contain'}}
            />

            <Box width={'425px'}>
              <Typography variant='body1' sx={bodyPdf}>
                {t('introductionPage.blockOne')}
              </Typography>
            </Box>
          </Grid>

          <Grid item container justifyContent={'space-between'} mt={4} alignItems={'center'}>
            <Grid item xs={8}>
              <Box>
                <Typography variant='body1' sx={bodyPdf}>
                  {t('introductionPage.blockTwo')}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={4} display='flex' justifyContent={'flex-end'}>
              <CardMedia
                component={'img'}
                image={introductionImage}
                sx={{height: '240px', width: '100%', maxWidth: '250px', objectFit: 'contain'}}
              />
            </Grid>
          </Grid>

          <Grid item container mt={2} alignItems={'center'}>
            <Grid item xs={12}>
              <Box width={'100%'} mr={2}>
                <Typography variant='body1' sx={bodyPdf}>
                  {t('introductionPage.blockThree')}
                </Typography>
                <Typography variant='body1' sx={bodyPdf} mt={1}>
                  {t('introductionPage.blockFour')}
                </Typography>
              </Box>
            </Grid>

            <Grid
              item
              container
              bgcolor={'white'}
              borderRadius={'16px'}
              height={'160px'}
              width={'410px'}
              alignSelf={'flex-start'}
              marginTop={4}
              border={`1px solid ${orangeColors[3]}`}
            >
              <CardMedia
                component={'img'}
                image={contactPersonImage}
                sx={{width: '160px', height: '160px', borderRadius: '16px 0px 0px 16px'}}
              />
              <Grid item p={2} alignContent={'center'}>
                <Typography sx={{...bodyPdf, fontWeight: '700', color: greenColors[900]}}>
                  {t('introductionPage.contactMe')}
                </Typography>
                <Typography sx={{...bodyPdf, color: greenColors[100]}} mb={2}>
                  {CONTACT_PERSON_EMAIL}
                </Typography>
                <Typography sx={{...bodyPdf, fontWeight: '700', color: greenColors[900]}}>
                  {CONTACT_PERSON_NAME}
                </Typography>
                <Typography sx={{...bodyPdf, color: greenColors[900]}}>{CONTACT_PERSON_POSITION}</Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
